import type { CoachRef, CoachSource } from '../../../api/types';

const STUDENT_TABS: Record<string, string> = { academics: 'academics', life: 'life', study_plan: 'study_plan', cases: 'cases' };

/** The panel page a coach source (or scope) opens. */
export function coachHref(kind: CoachSource['kind'], ref: CoachRef): string | null {
  if (kind === 'exam_result' && ref.student_id && ref.result_id) {
    return `/students/profile/${ref.student_id}?tab=academics&exam=${ref.result_id}`;
  }
  if (kind === 'student' && ref.student_id) {
    const tab = ref.tab ? STUDENT_TABS[ref.tab] : undefined;
    return `/students/profile/${ref.student_id}${tab ? `?tab=${tab}` : ''}`;
  }
  if (kind === 'exam' && ref.exam_id) return `/exams/report/${ref.exam_id}`;
  if (kind === 'class') return ref.section_id ? `/school/section/${ref.section_id}` : '/class-performance';
  return null;
}
